import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import DataSourceResource from '../../../DataSource.resource';
import NavigationService from '@ane/core/lib/services/NavigationService';
import { DataSourceRouteUtils } from '@ane/exp-data/lib/routes/DataSourceRoute.utils';
import { convertToPostParams } from '../components/CreateWizard/DataSourceCreateFormSettings';
export const defaultReducerState = {
    res: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'createDataSource';
const CLEAR_DATA_SOURCE_STATE = `${prefix}/CLEAR_STATE`;
export const clearCreateDataSourceState = () => {
    return {
        type: CLEAR_DATA_SOURCE_STATE,
        payload: {},
    };
};
const createDataSourceArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (inputPayload) => {
        let dataSourcePost = convertToPostParams(inputPayload);
        return DataSourceResource.postDataSource(dataSourcePost);
    },
    onCompleteSuccess: (resourceResult) => {
        if (!!resourceResult && !!resourceResult.Name) {
            NavigationService.navigateTo(DataSourceRouteUtils.routes.view.getURL({
                id: resourceResult === null || resourceResult === void 0 ? void 0 : resourceResult.Name,
            }));
        }
        return resourceResult;
    },
};
export const createDataSourceEpicReducer = loadResourcesUtils(createDataSourceArgs);
// Reducer
export const createDataSourceReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case CLEAR_DATA_SOURCE_STATE:
            return defaultReducerState;
        default:
            return createDataSourceEpicReducer.reduxChange(state, action);
    }
    return state;
};
export default createDataSourceReducer;

//# sourceMappingURL=DataSourceCreate.ducks.js.map
